<template>
    <div class="d-flex flex-wrap align-baseline">
        <div v-for="(spiel, i) in runde.getSpiele()"
             :key="runde.id + spiel.id"
             :class="[{'spielWidth': i%2===0}, {'spielWidthRight': i%2!==0}, 'd-inline-block'] ">
            <spiel-ko :class="[{'mt-15': i>0 && i===(breakRound16!==0?breakRound16+2:breakRound16)}]"
                      :spiel="spiel"
                      :is-print="true"
                      :settings-spiel="runde?.settings.spiel"
                      :bewerb-is-confirmed="true"
                      :is-operator="false"/>
            <div v-if="i>0 && i===breakRound16" class="pageBreak"></div>
        </div>
    </div>
</template>

<script>
import SpielKo from "@/views/ergebnisdienst/meisterschaft/spiele/spielKo.vue";

export default {
    name: "meisterschaftPrintRundeKo",
    components: {SpielKo},
    props: ['runde', 'spielTyp'],
    computed: {
        breakRound16(){
            return this.runde.settings.anzahlSpiele === 16 &&
                   this.runde.settings.spiel.saetze === 4 ?
                   this.spielTyp === 'einzel' ? 9 : 7 : 0;
        }
    },
}
</script>

<style scoped>
    .spielWidth {
        width: 8.8cm; margin-right: 0.4cm; margin-bottom: 0.4cm
    }
    .spielWidthRight {
        width: 8.8cm; margin-bottom: 0.4cm
    }
    .pageBreak {
        page-break-after: always;
        margin-top: 1.5cm
    }
</style>